import { t } from '@gem/modules/i18n';
import { media } from '@gem/modules/permissions';

import Tasks from 'APP/Tasks';

export const getAudioPermission = async (withAlert = true): Promise<boolean> => {
  const hasAudioPermission = await media.getAudioPermission();

  if (!hasAudioPermission && withAlert) {
    Tasks.app.showAlert(t('calls_no_microphone_permissions'));

    return false;
  } else if (!hasAudioPermission) {
    return false;
  }

  return true;
};
